const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

class PageSearchBar extends React.Component {
  static get defaultProps() {
    return {
      placeholderKey: '',
      containerClass: '',
    };
  }

  static get propTypes() {
    return {
      containerClass: PropTypes.string,
      query: PropTypes.string,
      placeholderKey: PropTypes.string,
      queryRoute: PropTypes.string,
    };
  }

  render() {
    return (
      <div className={classNames('page-search', this.props.containerClass)}>
        <form
          className="page-search__inner"
          action={this.props.queryRoute}
        >
          <input
            id="page-search-input"
            className="page-search__input"
            name="query"
            type="text"
            placeholder={I18n.t(this.props.placeholderKey)}
            defaultValue={this.props.query}
          />
          <input
            className="page-search__submit"
            type="submit"
            value={I18n.t('js.pageSearchBar.submit')}
          />
        </form>
      </div>
    );
  }
}

module.exports = PageSearchBar;



// WEBPACK FOOTER //
// ./javascripts/components/shared/page_search_bar.jsx